import React, { useEffect, useMemo, useState } from 'react';
import { BarChart2Icon, UserPlusIcon, DollarSignIcon, TrendingUpIcon, UsersIcon, GlobeIcon, FileTextIcon, BriefcaseIcon, ActivityIcon, LayoutDashboardIcon, SearchIcon, FilterIcon, RefreshCwIcon, CalendarIcon, DownloadIcon, ChevronDownIcon, MapIcon, PieChartIcon, LineChartIcon, BellIcon, ArrowUpIcon, ArrowDownIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, ZapIcon, ListIcon, GridIcon, EyeIcon, ClipboardCheckIcon, HeartIcon, BuildingIcon, HelpCircleIcon, StarIcon, BadgeIcon, LayersIcon, PercentIcon, ClockIcon, TargetIcon, FlagIcon, HashIcon, TagIcon, ShieldIcon, ThumbsUpIcon, MessageSquareIcon, LinkIcon, BarChart3Icon, CheckIcon, XIcon } from 'lucide-react';
import { LeadInsightsOverview } from '../components/dashboard/alternative/LeadInsightsOverview';
// Mock data for Lead Insights
const mockLeadData = {
  totalLeads: 1245,
  qualifiedLeads: 876,
  conversionRate: 12.4,
  avgResponseTime: 4.2,
  leadsBySource: [{
    source: 'Website',
    count: 540,
    percentage: 43
  }, {
    source: 'Social Media',
    count: 320,
    percentage: 26
  }, {
    source: 'Trade Shows',
    count: 210,
    percentage: 17
  }, {
    source: 'Referrals',
    count: 175,
    percentage: 14
  }],
  leadsByStatus: [{
    status: 'New',
    count: 320,
    percentage: 26
  }, {
    status: 'Contacted',
    count: 410,
    percentage: 33
  }, {
    status: 'Qualified',
    count: 290,
    percentage: 23
  }, {
    status: 'Unqualified',
    count: 225,
    percentage: 18
  }],
  leadsByRegion: [{
    region: 'North America',
    count: 480,
    percentage: 39
  }, {
    region: 'Europe',
    count: 350,
    percentage: 28
  }, {
    region: 'Asia Pacific',
    count: 240,
    percentage: 19
  }, {
    region: 'Latin America',
    count: 175,
    percentage: 14
  }]
};
// Mock data for Sales Performance
const mockSalesData = {
  totalQuotes: 876,
  activeQuotes: 320,
  expiredQuotes: 156,
  wonQuotes: 245,
  lostQuotes: 155,
  newCustomers: 124,
  interactions: 2345,
  conversionRate: 28.5,
  totalQuotedValue: 12500000,
  totalClosedValue: 3750000,
  averageQuoteTicket: 14269,
  averageOrderTicket: 15306,
  openQuotesValue: 8750000,
  avgQuoteToOrderTime: 14.3,
  avgDesignToQuoteTime: 5.2,
  avgInactivityTime: 8.5,
  designToQuoteConversion: 65,
  quoteToOrderConversion: 28,
  designToOrderConversion: 18,
  newCustomerConversion: 22,
  recurringCustomerConversion: 38,
  strategicCustomerConversion: 45,
  salesManagerPerformance: [{
    id: 1,
    name: 'John Smith',
    region: 'North America',
    quotes: 145,
    wonQuotes: 48,
    openQuotes: 65,
    lostQuotes: 32,
    quotedValue: 2100000,
    closedValue: 750000,
    newCustomers: 22,
    interactions: 456,
    avgCycleTime: 12.5,
    conversionRate: 33.1
  }, {
    id: 2,
    name: 'Maria Rodriguez',
    region: 'Latin America',
    quotes: 132,
    wonQuotes: 45,
    openQuotes: 55,
    lostQuotes: 32,
    quotedValue: 1800000,
    closedValue: 680000,
    newCustomers: 18,
    interactions: 390,
    avgCycleTime: 11.2,
    conversionRate: 34.1
  }, {
    id: 3,
    name: 'Robert Chen',
    region: 'Asia Pacific',
    quotes: 118,
    wonQuotes: 32,
    openQuotes: 58,
    lostQuotes: 28,
    quotedValue: 1650000,
    closedValue: 520000,
    newCustomers: 15,
    interactions: 345,
    avgCycleTime: 15.8,
    conversionRate: 27.1
  }, {
    id: 4,
    name: 'Emma Johnson',
    region: 'Europe',
    quotes: 156,
    wonQuotes: 52,
    openQuotes: 72,
    lostQuotes: 32,
    quotedValue: 2250000,
    closedValue: 820000,
    newCustomers: 24,
    interactions: 480,
    avgCycleTime: 13.4,
    conversionRate: 33.3
  }, {
    id: 5,
    name: 'Ahmed Hassan',
    region: 'Middle East',
    quotes: 98,
    wonQuotes: 24,
    openQuotes: 45,
    lostQuotes: 29,
    quotedValue: 1350000,
    closedValue: 410000,
    newCustomers: 12,
    interactions: 265,
    avgCycleTime: 16.2,
    conversionRate: 24.5
  }, {
    id: 6,
    name: 'Sofia Mendoza',
    region: 'Latin America',
    quotes: 112,
    wonQuotes: 34,
    openQuotes: 48,
    lostQuotes: 30,
    quotedValue: 1580000,
    closedValue: 540000,
    newCustomers: 16,
    interactions: 320,
    avgCycleTime: 14.7,
    conversionRate: 30.4
  }, {
    id: 7,
    name: 'James Wilson',
    region: 'North America',
    quotes: 115,
    wonQuotes: 38,
    openQuotes: 52,
    lostQuotes: 25,
    quotedValue: 1750000,
    closedValue: 630000,
    newCustomers: 17,
    interactions: 345,
    avgCycleTime: 12.8,
    conversionRate: 33.0
  }],
  regionPerformance: [{
    region: 'Norteamérica',
    quotes: 320,
    wonQuotes: 110,
    conversionRate: 34.4,
    avgCycleTime: 12.5
  }, {
    region: 'Europa',
    quotes: 280,
    wonQuotes: 85,
    conversionRate: 30.4,
    avgCycleTime: 14.2
  }, {
    region: 'Asia Pacífico',
    quotes: 145,
    wonQuotes: 38,
    conversionRate: 26.2,
    avgCycleTime: 16.8
  }, {
    region: 'Latinoamérica',
    quotes: 210,
    wonQuotes: 68,
    conversionRate: 32.4,
    avgCycleTime: 11.5
  }, {
    region: 'Medio Oriente',
    quotes: 95,
    wonQuotes: 22,
    conversionRate: 23.2,
    avgCycleTime: 18.3
  }],
  quotesByProduct: [{
    product: 'Center Pivots',
    count: 320,
    percentage: 36.5
  }, {
    product: 'Linear Systems',
    count: 245,
    percentage: 28.0
  }, {
    product: 'Drip Irrigation',
    count: 180,
    percentage: 20.5
  }, {
    product: 'Micro Sprinklers',
    count: 85,
    percentage: 9.7
  }, {
    product: 'Other Products',
    count: 46,
    percentage: 5.3
  }],
  salesTrend: [{
    month: 'Jan',
    quotes: 120,
    orders: 35
  }, {
    month: 'Feb',
    quotes: 145,
    orders: 42
  }, {
    month: 'Mar',
    quotes: 165,
    orders: 48
  }, {
    month: 'Apr',
    quotes: 155,
    orders: 45
  }, {
    month: 'May',
    quotes: 170,
    orders: 52
  }, {
    month: 'Jun',
    quotes: 190,
    orders: 58
  }, {
    month: 'Jul',
    quotes: 175,
    orders: 55
  }]
};
// Mock data for Customer Analytics
const mockCustomerData = {
  totalCustomers: 1450,
  activeCustomers: 980,
  newCustomersThisMonth: 85,
  customerRetentionRate: 78.5,
  totalDealers: 120,
  activeDealers: 98,
  customerLifetimeValue: 45600,
  customerAcquisitionCost: 1250,
  customersByRegion: [{
    region: 'North America',
    count: 480,
    percentage: 33.1
  }, {
    region: 'Europe',
    count: 350,
    percentage: 24.1
  }, {
    region: 'Asia Pacific',
    count: 320,
    percentage: 22.1
  }, {
    region: 'Latin America',
    count: 210,
    percentage: 14.5
  }, {
    region: 'Middle East',
    count: 90,
    percentage: 6.2
  }],
  customersByType: [{
    type: 'Dealers',
    count: 120,
    percentage: 8.3
  }, {
    type: 'End Customers',
    count: 850,
    percentage: 58.6
  }, {
    type: 'Distributors',
    count: 65,
    percentage: 4.5
  }, {
    type: 'Contractors',
    count: 415,
    percentage: 28.6
  }]
};
// Mock data for Market Insights
const mockMarketData = {
  marketShareByRegion: [{
    region: 'North America',
    share: 28.5,
    trend: 'up',
    change: 2.3
  }, {
    region: 'Europe',
    share: 22.4,
    trend: 'up',
    change: 1.5
  }, {
    region: 'Asia Pacific',
    share: 18.2,
    trend: 'up',
    change: 3.2
  }, {
    region: 'Latin America',
    share: 32.6,
    trend: 'up',
    change: 4.1
  }, {
    region: 'Middle East',
    share: 15.8,
    trend: 'down',
    change: 1.2
  }],
  competitorComparison: [{
    competitor: 'Our Company',
    marketShare: 24.5,
    growthRate: 3.2
  }, {
    competitor: 'Competitor A',
    marketShare: 18.2,
    growthRate: 1.8
  }, {
    competitor: 'Competitor B',
    marketShare: 15.6,
    growthRate: 2.1
  }, {
    competitor: 'Competitor C',
    marketShare: 12.3,
    growthRate: -0.5
  }, {
    competitor: 'Others',
    marketShare: 29.4,
    growthRate: 0.3
  }],
  productMarketGrowth: [{
    product: 'Center Pivots',
    growth: 4.5,
    marketSize: 850
  }, {
    product: 'Linear Systems',
    growth: 3.2,
    marketSize: 620
  }, {
    product: 'Drip Irrigation',
    growth: 5.8,
    marketSize: 780
  }, {
    product: 'Micro Sprinklers',
    growth: 2.1,
    marketSize: 340
  }]
};
// Mock data for Revenue Intelligence
const mockRevenueData = {
  totalRevenue: 12500000,
  revenueGrowth: 8.5,
  forecastRevenue: 14200000,
  revenueByProduct: [{
    product: 'Center Pivots',
    revenue: 5250000,
    percentage: 42
  }, {
    product: 'Linear Systems',
    revenue: 3125000,
    percentage: 25
  }, {
    product: 'Drip Irrigation',
    revenue: 2500000,
    percentage: 20
  }, {
    product: 'Micro Sprinklers',
    revenue: 1000000,
    percentage: 8
  }, {
    product: 'Other Products',
    revenue: 625000,
    percentage: 5
  }],
  revenueByRegion: [{
    region: 'North America',
    revenue: 4375000,
    percentage: 35
  }, {
    region: 'Europe',
    revenue: 3125000,
    percentage: 25
  }, {
    region: 'Asia Pacific',
    revenue: 2500000,
    percentage: 20
  }, {
    region: 'Latin America',
    revenue: 1875000,
    percentage: 15
  }, {
    region: 'Middle East',
    revenue: 625000,
    percentage: 5
  }],
  monthlyRevenue: [{
    month: 'Jan',
    revenue: 980000
  }, {
    month: 'Feb',
    revenue: 1050000
  }, {
    month: 'Mar',
    revenue: 1120000
  }, {
    month: 'Apr',
    revenue: 1080000
  }, {
    month: 'May',
    revenue: 1150000
  }, {
    month: 'Jun',
    revenue: 1220000
  }, {
    month: 'Jul',
    revenue: 1180000
  }]
};
// Mock sales managers data
const mockSalesManagers = [{
  id: 1,
  name: 'John Smith',
  region: 'North America',
  avatar: 'JS',
  color: 'bg-blue-500'
}, {
  id: 2,
  name: 'Maria Rodriguez',
  region: 'Latin America',
  avatar: 'MR',
  color: 'bg-green-500'
}, {
  id: 3,
  name: 'Robert Chen',
  region: 'Asia Pacific',
  avatar: 'RC',
  color: 'bg-purple-500'
}, {
  id: 4,
  name: 'Emma Johnson',
  region: 'Europe',
  avatar: 'EJ',
  color: 'bg-amber-500'
}, {
  id: 5,
  name: 'Ahmed Hassan',
  region: 'Middle East',
  avatar: 'AH',
  color: 'bg-red-500'
}, {
  id: 6,
  name: 'Sofia Mendoza',
  region: 'Latin America',
  avatar: 'SM',
  color: 'bg-indigo-500'
}, {
  id: 7,
  name: 'James Wilson',
  region: 'North America',
  avatar: 'JW',
  color: 'bg-teal-500'
}];
// NavButton component
function NavButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button className={`flex items-center px-4 py-2 text-sm ${active ? 'text-white bg-blue-800/50 border-b-2 border-blue-500' : 'text-blue-300 hover:text-white hover:bg-blue-800/30'} transition-colors`} onClick={onClick} data-id="element-7362">
      <span className="mr-2" data-id="element-7363">{icon}</span>
      {label}
    </button>;
}
export function BusinessIntelligencePage() {
  const [activeSection, setActiveSection] = useState('lead-insights');
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-7364">
      {/* Header */}
      <div className="relative z-10 flex items-center justify-between p-6 border-b border-blue-800/30" data-id="element-7365">
        <div className="flex items-center" data-id="element-7366">
          <div className="p-2 mr-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center" data-id="element-7367">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eJcyBj2puhjmA95iiZVfaB/cyborg.svg" alt="Business Intelligence" className="w-5 h-5 filter brightness-0 invert" data-id="element-7368" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-7369">
            Business Intelligence
          </h1>
        </div>
        <div className="flex items-center space-x-4" data-id="element-7370">
          <div className="relative" data-id="element-7371">
            <input type="text" placeholder="Search analytics..." value={searchQuery} onChange={handleSearchChange} className="pl-10 pr-4 py-2 bg-blue-900/30 border border-blue-800/30 rounded-lg text-white placeholder-blue-300 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-7372" />
            <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={18} data-id="element-7373" />
            {searchQuery && <button onClick={() => setSearchQuery('')} className="absolute right-3 top-2.5 text-blue-300 hover:text-white" data-id="element-7374">
                <XIcon size={16} data-id="element-7375" />
              </button>}
          </div>
          <button className="flex items-center px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg text-blue-200 border border-blue-700/30 transition-colors" data-id="element-7376">
            <CalendarIcon size={18} className="mr-2" data-id="element-7377" />
            Last 30 Days
            <ChevronDownIcon size={16} className="ml-2" data-id="element-7378" />
          </button>
          <button className="flex items-center px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg text-blue-200 border border-blue-700/30 transition-colors" data-id="element-7379">
            <DownloadIcon size={18} className="mr-2" data-id="element-7380" />
            Export
          </button>
          <div className="relative" data-id="element-7381">
            <BellIcon size={20} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-7382" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-7383">
              3
            </span>
          </div>
        </div>
      </div>
      {/* Navigation Tabs */}
      <div className="flex px-6 py-2 overflow-x-auto border-b border-blue-800/30" data-id="element-7384">
        <NavButton icon={<UserPlusIcon size={18} data-id="element-7386" />} label="Lead Insights" active={activeSection === 'lead-insights'} onClick={() => setActiveSection('lead-insights')} data-id="element-7385" />
        <NavButton icon={<TrendingUpIcon size={18} data-id="element-7388" />} label="Sales Performance" active={activeSection === 'sales-performance'} onClick={() => setActiveSection('sales-performance')} data-id="element-7387" />
        <NavButton icon={<UsersIcon size={18} data-id="element-7390" />} label="Customer Analytics" active={activeSection === 'customer-analytics'} onClick={() => setActiveSection('customer-analytics')} data-id="element-7389" />
        <NavButton icon={<GlobeIcon size={18} data-id="element-7392" />} label="Market Insights" active={activeSection === 'market-insights'} onClick={() => setActiveSection('market-insights')} data-id="element-7391" />
        <NavButton icon={<FileTextIcon size={18} data-id="element-7394" />} label="Quote Intelligence" active={activeSection === 'quote-intelligence'} onClick={() => setActiveSection('quote-intelligence')} data-id="element-7393" />
        <NavButton icon={<DollarSignIcon size={18} data-id="element-7396" />} label="Revenue Intelligence" active={activeSection === 'revenue-intelligence'} onClick={() => setActiveSection('revenue-intelligence')} data-id="element-7395" />
        <NavButton icon={<ActivityIcon size={18} data-id="element-7398" />} label="Engagement" active={activeSection === 'engagement'} onClick={() => setActiveSection('engagement')} data-id="element-7397" />
        <NavButton icon={<LayoutDashboardIcon size={18} data-id="element-7400" />} label="Executive Insights" active={activeSection === 'executive-insights'} onClick={() => setActiveSection('executive-insights')} data-id="element-7399" />
      </div>
      {/* Main Content */}
      <div className="p-6" data-id="element-7401">
        {activeSection === 'lead-insights' && <LeadInsightsSection data={mockLeadData} searchQuery={searchQuery} data-id="element-7402" />}
        {activeSection === 'sales-performance' && <SalesPerformanceSection data={mockSalesData} searchQuery={searchQuery} data-id="element-7403" />}
        {activeSection === 'customer-analytics' && <CustomerAnalyticsSection data={mockCustomerData} searchQuery={searchQuery} data-id="element-7404" />}
        {activeSection === 'market-insights' && <MarketInsightsSection data={mockMarketData} searchQuery={searchQuery} data-id="element-7405" />}
        {activeSection === 'quote-intelligence' && <QuoteIntelligenceSection searchQuery={searchQuery} data-id="element-7406" />}
        {activeSection === 'revenue-intelligence' && <RevenueIntelligenceSection data={mockRevenueData} searchQuery={searchQuery} data-id="element-7407" />}
        {activeSection === 'engagement' && <EngagementSection searchQuery={searchQuery} data-id="element-7408" />}
        {activeSection === 'executive-insights' && <ExecutiveInsightsSection searchQuery={searchQuery} data-id="element-7409" />}
      </div>
    </div>;
}
// ... existing function components ...
function LeadInsightsSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <LeadInsightsOverview data-id="element-7410" />;
}
function SalesPerformanceSection({
  data,
  searchQuery = ''
}) {
  const [selectedManagers, setSelectedManagers] = useState([]);
  const [showManagerFilter, setShowManagerFilter] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState('month');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });
  const [isCustomDateRange, setIsCustomDateRange] = useState(false);
  const [filteredSalesManagers, setFilteredSalesManagers] = useState(mockSalesManagers);
  const [filteredRegions, setFilteredRegions] = useState(data.regionPerformance);
  const [filteredProducts, setFilteredProducts] = useState(data.quotesByProduct);
  const [visibleSections, setVisibleSections] = useState({
    activityVolume: true,
    conversionRate: true,
    economicValue: true,
    salesCycle: true,
    internalRanking: true,
    productCharts: true,
    salesTrend: true
  });
  // Filtrar datos basados en la búsqueda
  useEffect(() => {
    if (!searchQuery) {
      // Restaurar todos los datos cuando no hay búsqueda
      setFilteredSalesManagers(mockSalesManagers);
      setFilteredRegions(data.regionPerformance);
      setFilteredProducts(data.quotesByProduct);
      setVisibleSections({
        activityVolume: true,
        conversionRate: true,
        economicValue: true,
        salesCycle: true,
        internalRanking: true,
        productCharts: true,
        salesTrend: true
      });
      return;
    }
    const query = searchQuery.toLowerCase();
    // Filtrar gerentes de ventas
    const managers = mockSalesManagers.filter(manager => manager.name.toLowerCase().includes(query) || manager.region.toLowerCase().includes(query));
    setFilteredSalesManagers(managers);
    // Filtrar regiones
    const regions = data.regionPerformance.filter(region => region.region.toLowerCase().includes(query));
    setFilteredRegions(regions);
    // Filtrar productos
    const products = data.quotesByProduct.filter(product => product.product.toLowerCase().includes(query));
    setFilteredProducts(products);
    // Determinar qué secciones mostrar basado en la búsqueda
    setVisibleSections({
      activityVolume: 'cotizaciones'.includes(query) || 'clientes'.includes(query) || 'interacciones'.includes(query) || 'actividad'.includes(query),
      conversionRate: 'conversión'.includes(query) || 'tasa'.includes(query) || 'porcentaje'.includes(query) || 'quote'.includes(query) || 'orden'.includes(query),
      economicValue: 'valor'.includes(query) || 'económico'.includes(query) || 'ticket'.includes(query) || 'cotizado'.includes(query) || 'cerrado'.includes(query) || 'potencial'.includes(query),
      salesCycle: 'ciclo'.includes(query) || 'tiempo'.includes(query) || 'días'.includes(query) || 'inactividad'.includes(query),
      internalRanking: 'ranking'.includes(query) || 'gerentes'.includes(query) || 'managers'.includes(query) || 'región'.includes(query) || 'regiones'.includes(query),
      productCharts: 'producto'.includes(query) || 'productos'.includes(query) || 'pivot'.includes(query) || 'linear'.includes(query) || 'drip'.includes(query),
      salesTrend: 'tendencia'.includes(query) || 'ventas'.includes(query) || 'mensual'.includes(query) || 'mes'.includes(query)
    });
    // Si la búsqueda no coincide con ninguna sección específica, mostrar todas
    if (!Object.values(visibleSections).some(value => value)) {
      setVisibleSections({
        activityVolume: true,
        conversionRate: true,
        economicValue: true,
        salesCycle: true,
        internalRanking: true,
        productCharts: true,
        salesTrend: true
      });
    }
  }, [searchQuery, data]);
  // Filter data based on selected managers
  const filteredData = useMemo(() => {
    if (selectedManagers.length === 0) {
      return data;
    }
    // Filter sales manager performance
    const filteredManagers = data.salesManagerPerformance.filter(manager => selectedManagers.includes(manager.id));
    // Calculate aggregate metrics based on filtered managers
    const totalQuotes = filteredManagers.reduce((sum, manager) => sum + manager.quotes, 0);
    const wonQuotes = filteredManagers.reduce((sum, manager) => sum + manager.wonQuotes, 0);
    const openQuotes = filteredManagers.reduce((sum, manager) => sum + manager.openQuotes, 0);
    const lostQuotes = filteredManagers.reduce((sum, manager) => sum + manager.lostQuotes, 0);
    const quotedValue = filteredManagers.reduce((sum, manager) => sum + manager.quotedValue, 0);
    const closedValue = filteredManagers.reduce((sum, manager) => sum + manager.closedValue, 0);
    const newCustomers = filteredManagers.reduce((sum, manager) => sum + manager.newCustomers, 0);
    const interactions = filteredManagers.reduce((sum, manager) => sum + manager.interactions, 0);
    // Calculate averages
    const avgConversionRate = totalQuotes > 0 ? wonQuotes / totalQuotes * 100 : 0;
    const avgTicket = totalQuotes > 0 ? quotedValue / totalQuotes : 0;
    const avgCycleTime = filteredManagers.reduce((sum, manager) => sum + manager.avgCycleTime, 0) / filteredManagers.length;
    return {
      ...data,
      totalQuotes,
      activeQuotes: openQuotes,
      expiredQuotes: lostQuotes,
      wonQuotes,
      lostQuotes,
      newCustomers,
      interactions,
      conversionRate: avgConversionRate,
      totalQuotedValue: quotedValue,
      totalClosedValue: closedValue,
      averageQuoteTicket: avgTicket,
      openQuotesValue: quotedValue - closedValue,
      avgQuoteToOrderTime: avgCycleTime
    };
  }, [data, selectedManagers]);
  // ... existing functions ...
  const toggleManager = managerId => {
    setSelectedManagers(prev => prev.includes(managerId) ? prev.filter(id => id !== managerId) : [...prev, managerId]);
  };
  const handleDateRangeChange = e => {
    const value = e.target.value;
    setSelectedDateRange(value);
    setIsCustomDateRange(value === 'custom');
    if (value !== 'custom') {
      // Set predefined date ranges
      const endDate = new Date().toISOString().split('T')[0];
      let startDate;
      switch (value) {
        case 'week':
          startDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0];
          break;
        case 'month':
          startDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0];
          break;
        case 'quarter':
          startDate = new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split('T')[0];
          break;
        case 'year':
          startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
          break;
        default:
          startDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0];
      }
      setDateRange({
        startDate,
        endDate
      });
    }
  };
  const handleDateChange = (type, value) => {
    setDateRange(prev => ({
      ...prev,
      [type]: value
    }));
  };
  const clearFilters = () => {
    setSelectedManagers([]);
    setSelectedDateRange('month');
    setIsCustomDateRange(false);
    setDateRange({
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0]
    });
  };
  // Get date range display text
  const getDateRangeText = () => {
    if (isCustomDateRange) {
      return `${dateRange.startDate} - ${dateRange.endDate}`;
    }
    switch (selectedDateRange) {
      case 'week':
        return 'Últimos 7 días';
      case 'month':
        return 'Últimos 30 días';
      case 'quarter':
        return 'Últimos 90 días';
      case 'year':
        return 'Último año';
      default:
        return 'Últimos 30 días';
    }
  };
  // Renderizar mensaje cuando no hay resultados de búsqueda
  const renderNoResults = () => {
    if (!searchQuery) return null;
    const noVisibleSections = !Object.values(visibleSections).some(value => value);
    if (noVisibleSections) {
      return <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-blue-800/30 text-center" data-id="element-7411">
          <SearchIcon size={40} className="mx-auto mb-4 text-blue-300 opacity-50" data-id="element-7412" />
          <h3 className="text-xl font-medium text-white mb-2" data-id="element-7413">
            No se encontraron resultados
          </h3>
          <p className="text-blue-300" data-id="element-7414">
            No se encontraron paneles que coincidan con "{searchQuery}". Intenta
            con otros términos o{' '}
            <button onClick={() => setSearchQuery('')} className="text-blue-400 hover:text-blue-300 underline" data-id="element-7415">
              limpia la búsqueda
            </button>
            .
          </p>
        </div>;
    }
    return null;
  };
  return <div className="space-y-6" data-id="element-7416">
      {/* Filter Bar - Rediseñado */}
      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7417">
        <div className="flex flex-col gap-4" data-id="element-7418">
          <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-7419">
            <div className="flex items-center" data-id="element-7420">
              <FilterIcon size={20} className="text-blue-300 mr-2" data-id="element-7421" />
              <span className="text-white font-semibold text-lg" data-id="element-7422">
                Filtros de Rendimiento
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-7423">
              <button className="flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white transition-colors shadow-md" data-id="element-7424">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-7425" />
                Actualizar datos
              </button>
            </div>
          </div>
          {/* Main Filters Row - Rediseñado */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7426">
            {/* Date Range Filter */}
            <div data-id="element-7427">
              <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-7428">
                Período de tiempo
              </label>
              <div className="flex gap-2" data-id="element-7429">
                <div className="relative flex-1" data-id="element-7430">
                  <select value={selectedDateRange} onChange={handleDateRangeChange} className="w-full appearance-none bg-blue-900/60 border border-blue-700/40 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm" data-id="element-7431">
                    <option value="week" data-id="element-7432">Últimos 7 días</option>
                    <option value="month" data-id="element-7433">Últimos 30 días</option>
                    <option value="quarter" data-id="element-7434">Últimos 90 días</option>
                    <option value="year" data-id="element-7435">Último año</option>
                    <option value="custom" data-id="element-7436">Personalizado</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-blue-300" data-id="element-7437">
                    <ChevronDownIcon size={18} data-id="element-7438" />
                  </div>
                </div>
                <button onClick={() => setShowDatePicker(!showDatePicker)} className="flex items-center px-4 py-2.5 bg-blue-900/60 hover:bg-blue-900/80 rounded-lg text-white border border-blue-700/40 transition-colors shadow-sm" data-id="element-7439">
                  <CalendarIcon size={18} className="mr-2 text-blue-300" data-id="element-7440" />
                  {getDateRangeText()}
                </button>
              </div>
            </div>
            {/* Sales Managers Filter */}
            <div className="relative" data-id="element-7441">
              <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-7442">
                Gerentes de ventas
              </label>
              <button onClick={() => setShowManagerFilter(!showManagerFilter)} className="w-full flex items-center justify-between px-4 py-2.5 bg-blue-900/60 hover:bg-blue-900/80 rounded-lg text-white border border-blue-700/40 transition-colors shadow-sm" data-id="element-7443">
                <div className="flex items-center" data-id="element-7444">
                  <UsersIcon size={18} className="mr-2 text-blue-300" data-id="element-7445" />
                  {selectedManagers.length === 0 ? 'Todos los gerentes' : `${selectedManagers.length} gerente${selectedManagers.length > 1 ? 's' : ''} seleccionado${selectedManagers.length > 1 ? 's' : ''}`}
                </div>
                <ChevronDownIcon size={18} className="text-blue-300" data-id="element-7446" />
              </button>
            </div>
          </div>
          {/* Selected Filters Tags */}
          {(selectedManagers.length > 0 || isCustomDateRange) && <div className="flex flex-wrap gap-2 mt-2 items-center" data-id="element-7447">
              {isCustomDateRange && <div className="flex items-center px-2 py-1 bg-blue-800/50 rounded-full text-sm text-white border border-blue-700/40" data-id="element-7448">
                  <CalendarIcon size={14} className="mr-1.5 text-blue-300" data-id="element-7449" />
                  {dateRange.startDate} - {dateRange.endDate}
                  <button onClick={() => {
              setSelectedDateRange('month');
              setIsCustomDateRange(false);
              setDateRange({
                startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
                endDate: new Date().toISOString().split('T')[0]
              });
            }} className="ml-1.5 text-blue-300 hover:text-white" data-id="element-7450">
                    <XIcon size={14} data-id="element-7451" />
                  </button>
                </div>}
              {selectedManagers.map(managerId => {
            const manager = mockSalesManagers.find(m => m.id === managerId);
            return <div key={manager.id} className="flex items-center px-2 py-1 bg-blue-800/50 rounded-full text-sm text-white border border-blue-700/40" data-id="element-7452">
                    <div className={`w-4 h-4 rounded-full ${manager.color} flex items-center justify-center text-xs text-white mr-1.5`} data-id="element-7453">
                      {manager.avatar}
                    </div>
                    {manager.name}
                    <button onClick={() => toggleManager(manager.id)} className="ml-1.5 text-blue-300 hover:text-white" data-id="element-7454">
                      <XIcon size={14} data-id="element-7455" />
                    </button>
                  </div>;
          })}
              {(selectedManagers.length > 0 || isCustomDateRange) && <button onClick={clearFilters} className="flex items-center px-2.5 py-1 bg-blue-800/30 hover:bg-blue-800/50 rounded-full text-xs text-blue-200 border border-blue-700/30" data-id="element-7456">
                  Limpiar todos los filtros
                </button>}
            </div>}
        </div>
      </div>
      {/* Mensaje de no resultados */}
      {renderNoResults()}
      {/* KPI Summary Cards - Volumen de actividad */}
      {visibleSections.activityVolume && <div data-id="element-7457">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7458">
            <BarChart3Icon size={18} className="mr-2 text-blue-400" data-id="element-7459" />
            Volumen de actividad
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-7460">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7461">
              <div className="flex items-center justify-between mb-2" data-id="element-7462">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7463">
                  Cotizaciones
                </h3>
                <FileTextIcon className="text-blue-400" size={20} data-id="element-7464" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7465">
                {filteredData.totalQuotes.toLocaleString()}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7466">
                <div className="flex items-center text-blue-300" data-id="element-7467">
                  <span data-id="element-7468">
                    {filteredData.activeQuotes} abiertas,{' '}
                    {filteredData.wonQuotes} ganadas, {filteredData.lostQuotes}{' '}
                    perdidas
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7469">
              <div className="flex items-center justify-between mb-2" data-id="element-7470">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7471">
                  Clientes Nuevos
                </h3>
                <UserPlusIcon className="text-green-400" size={20} data-id="element-7472" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7473">
                {filteredData.newCustomers}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7474">
                <div className="flex items-center text-green-400" data-id="element-7475">
                  <ArrowUpIcon size={14} className="mr-1" data-id="element-7476" />
                  <span data-id="element-7477">+12% vs mes anterior</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7478">
              <div className="flex items-center justify-between mb-2" data-id="element-7479">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7480">
                  Interacciones
                </h3>
                <MessageSquareIcon className="text-amber-400" size={20} data-id="element-7481" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7482">
                {filteredData.interactions.toLocaleString()}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7483">
                <div className="flex items-center text-blue-300" data-id="element-7484">
                  <span data-id="element-7485">Seguimientos, notas y recordatorios</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7486">
              <div className="flex items-center justify-between mb-2" data-id="element-7487">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7488">
                  Actividad Promedio
                </h3>
                <ActivityIcon className="text-purple-400" size={20} data-id="element-7489" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7490">
                {(filteredData.interactions / filteredData.totalQuotes).toFixed(1)}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7491">
                <div className="flex items-center text-blue-300" data-id="element-7492">
                  <span data-id="element-7493">Interacciones por cotización</span>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Tasa de conversión */}
      {visibleSections.conversionRate && <div data-id="element-7494">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7495">
            <PercentIcon size={18} className="mr-2 text-blue-400" data-id="element-7496" />
            Tasa de conversión
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7497">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7498">
              <div className="flex items-center justify-between mb-2" data-id="element-7499">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7500">
                  Quote → Orden
                </h3>
                <TrendingUpIcon className="text-green-400" size={20} data-id="element-7501" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7502">
                {filteredData.conversionRate.toFixed(1)}%
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7503">
                <div className="flex items-center text-green-400" data-id="element-7504">
                  <ArrowUpIcon size={14} className="mr-1" data-id="element-7505" />
                  <span data-id="element-7506">+2.3% vs trimestre anterior</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7507">
              <div className="flex items-center justify-between mb-2" data-id="element-7508">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7509">
                  Conversión por Etapa
                </h3>
                <LayersIcon className="text-blue-400" size={20} data-id="element-7510" />
              </div>
              <div className="space-y-2 mt-2" data-id="element-7511">
                <div data-id="element-7512">
                  <div className="flex justify-between items-center" data-id="element-7513">
                    <span className="text-xs text-blue-200" data-id="element-7514">
                      Diseño → Quote
                    </span>
                    <span className="text-xs text-white" data-id="element-7515">
                      {filteredData.designToQuoteConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7516">
                    <div className="h-1.5 rounded-full bg-blue-500" style={{
                  width: `${filteredData.designToQuoteConversion}%`
                }} data-id="element-7517"></div>
                  </div>
                </div>
                <div data-id="element-7518">
                  <div className="flex justify-between items-center" data-id="element-7519">
                    <span className="text-xs text-blue-200" data-id="element-7520">Quote → Orden</span>
                    <span className="text-xs text-white" data-id="element-7521">
                      {filteredData.quoteToOrderConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7522">
                    <div className="h-1.5 rounded-full bg-green-500" style={{
                  width: `${filteredData.quoteToOrderConversion}%`
                }} data-id="element-7523"></div>
                  </div>
                </div>
                <div data-id="element-7524">
                  <div className="flex justify-between items-center" data-id="element-7525">
                    <span className="text-xs text-blue-200" data-id="element-7526">
                      Diseño → Orden
                    </span>
                    <span className="text-xs text-white" data-id="element-7527">
                      {filteredData.designToOrderConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7528">
                    <div className="h-1.5 rounded-full bg-purple-500" style={{
                  width: `${filteredData.designToOrderConversion}%`
                }} data-id="element-7529"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7530">
              <div className="flex items-center justify-between mb-2" data-id="element-7531">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7532">
                  Conversión por Tipo de Cliente
                </h3>
                <UsersIcon className="text-amber-400" size={20} data-id="element-7533" />
              </div>
              <div className="space-y-2 mt-2" data-id="element-7534">
                <div data-id="element-7535">
                  <div className="flex justify-between items-center" data-id="element-7536">
                    <span className="text-xs text-blue-200" data-id="element-7537">Nuevos</span>
                    <span className="text-xs text-white" data-id="element-7538">
                      {filteredData.newCustomerConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7539">
                    <div className="h-1.5 rounded-full bg-blue-500" style={{
                  width: `${filteredData.newCustomerConversion}%`
                }} data-id="element-7540"></div>
                  </div>
                </div>
                <div data-id="element-7541">
                  <div className="flex justify-between items-center" data-id="element-7542">
                    <span className="text-xs text-blue-200" data-id="element-7543">Recurrentes</span>
                    <span className="text-xs text-white" data-id="element-7544">
                      {filteredData.recurringCustomerConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7545">
                    <div className="h-1.5 rounded-full bg-green-500" style={{
                  width: `${filteredData.recurringCustomerConversion}%`
                }} data-id="element-7546"></div>
                  </div>
                </div>
                <div data-id="element-7547">
                  <div className="flex justify-between items-center" data-id="element-7548">
                    <span className="text-xs text-blue-200" data-id="element-7549">Estratégicos</span>
                    <span className="text-xs text-white" data-id="element-7550">
                      {filteredData.strategicCustomerConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7551">
                    <div className="h-1.5 rounded-full bg-amber-500" style={{
                  width: `${filteredData.strategicCustomerConversion}%`
                }} data-id="element-7552"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Valor económico */}
      {visibleSections.economicValue && <div data-id="element-7553">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7554">
            <DollarSignIcon size={18} className="mr-2 text-blue-400" data-id="element-7555" />
            Valor económico
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-7556">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7557">
              <div className="flex items-center justify-between mb-2" data-id="element-7558">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7559">
                  Valor Cotizado vs Cerrado
                </h3>
                <TrendingUpIcon className="text-green-400" size={20} data-id="element-7560" />
              </div>
              <div className="flex justify-between items-center" data-id="element-7561">
                <div data-id="element-7562">
                  <div className="text-sm text-blue-200" data-id="element-7563">Valor Cotizado</div>
                  <div className="text-2xl font-bold text-white" data-id="element-7564">
                    ${(filteredData.totalQuotedValue / 1000000).toFixed(1)}M
                  </div>
                </div>
                <div className="text-2xl text-blue-300 px-2" data-id="element-7565">vs</div>
                <div className="text-right" data-id="element-7566">
                  <div className="text-sm text-blue-200" data-id="element-7567">Valor Cerrado</div>
                  <div className="text-2xl font-bold text-green-400" data-id="element-7568">
                    ${(filteredData.totalClosedValue / 1000000).toFixed(1)}M
                  </div>
                </div>
              </div>
              <div className="w-full bg-blue-900/50 rounded-full h-2 mt-3" data-id="element-7569">
                <div className="h-2 rounded-full bg-green-500" style={{
              width: `${filteredData.totalClosedValue / filteredData.totalQuotedValue * 100}%`
            }} data-id="element-7570"></div>
              </div>
              <div className="flex justify-between mt-1" data-id="element-7571">
                <span className="text-xs text-blue-300" data-id="element-7572">
                  {(filteredData.totalClosedValue / filteredData.totalQuotedValue * 100).toFixed(1)}
                  % del valor cotizado
                </span>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7573">
              <div className="flex items-center justify-between mb-2" data-id="element-7574">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7575">
                  Ticket Promedio
                </h3>
                <HashIcon className="text-amber-400" size={20} data-id="element-7576" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-7577">
                <div data-id="element-7578">
                  <div className="text-sm text-blue-200" data-id="element-7579">Por Cotización</div>
                  <div className="text-2xl font-bold text-white" data-id="element-7580">
                    ${(filteredData.averageQuoteTicket / 1000).toFixed(1)}K
                  </div>
                  <div className="text-xs text-blue-300 mt-1" data-id="element-7581">
                    Promedio global
                  </div>
                </div>
                <div data-id="element-7582">
                  <div className="text-sm text-blue-200" data-id="element-7583">Por Orden</div>
                  <div className="text-2xl font-bold text-green-400" data-id="element-7584">
                    ${(filteredData.averageOrderTicket / 1000).toFixed(1)}K
                  </div>
                  <div className="text-xs text-green-400 mt-1" data-id="element-7585">
                    <ArrowUpIcon size={10} className="inline mr-1" data-id="element-7586" />
                    +5.2% vs año anterior
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7587">
              <div className="flex items-center justify-between mb-2" data-id="element-7588">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7589">
                  Valor Potencial
                </h3>
                <TargetIcon className="text-purple-400" size={20} data-id="element-7590" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7591">
                ${(filteredData.openQuotesValue / 1000000).toFixed(1)}M
              </div>
              <div className="text-sm text-blue-200 mt-2" data-id="element-7592">
                Valor de cotizaciones abiertas
              </div>
              <div className="flex items-center mt-2" data-id="element-7593">
                <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7594">
                  <div className="h-2 rounded-full bg-purple-500" style={{
                width: `${filteredData.activeQuotes / filteredData.totalQuotes * 100}%`
              }} data-id="element-7595"></div>
                </div>
              </div>
              <div className="text-xs text-blue-300 mt-1" data-id="element-7596">
                {filteredData.activeQuotes} cotizaciones abiertas (
                {(filteredData.activeQuotes / filteredData.totalQuotes * 100).toFixed(1)}
                %)
              </div>
            </div>
          </div>
        </div>}
      {/* Tiempo de ciclo de ventas */}
      {visibleSections.salesCycle && <div data-id="element-7597">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7598">
            <ClockIcon size={18} className="mr-2 text-blue-400" data-id="element-7599" />
            Tiempo de ciclo de ventas
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7600">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7601">
              <div className="flex items-center justify-between mb-2" data-id="element-7602">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7603">
                  Tiempo por Etapa
                </h3>
                <LayersIcon className="text-blue-400" size={20} data-id="element-7604" />
              </div>
              <div className="space-y-4 mt-2" data-id="element-7605">
                <div data-id="element-7606">
                  <div className="flex justify-between items-center mb-1" data-id="element-7607">
                    <span className="text-sm text-blue-200" data-id="element-7608">
                      Diseño → Quote
                    </span>
                    <span className="text-sm text-white" data-id="element-7609">
                      {filteredData.avgDesignToQuoteTime} días
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7610">
                    <div className="h-2 rounded-full bg-blue-500" style={{
                  width: `${filteredData.avgDesignToQuoteTime / 20 * 100}%`
                }} data-id="element-7611"></div>
                  </div>
                </div>
                <div data-id="element-7612">
                  <div className="flex justify-between items-center mb-1" data-id="element-7613">
                    <span className="text-sm text-blue-200" data-id="element-7614">Quote → Orden</span>
                    <span className="text-sm text-white" data-id="element-7615">
                      {filteredData.avgQuoteToOrderTime} días
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7616">
                    <div className="h-2 rounded-full bg-green-500" style={{
                  width: `${filteredData.avgQuoteToOrderTime / 20 * 100}%`
                }} data-id="element-7617"></div>
                  </div>
                </div>
                <div data-id="element-7618">
                  <div className="flex justify-between items-center mb-1" data-id="element-7619">
                    <span className="text-sm text-blue-200" data-id="element-7620">Ciclo Total</span>
                    <span className="text-sm text-white" data-id="element-7621">
                      {(filteredData.avgDesignToQuoteTime + filteredData.avgQuoteToOrderTime).toFixed(1)}{' '}
                      días
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7622">
                    <div className="h-2 rounded-full bg-purple-500" style={{
                  width: `${(filteredData.avgDesignToQuoteTime + filteredData.avgQuoteToOrderTime) / 20 * 100}%`
                }} data-id="element-7623"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7624">
              <div className="flex items-center justify-between mb-2" data-id="element-7625">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7626">
                  Tiempos de Inactividad
                </h3>
                <AlertTriangleIcon className="text-amber-400" size={20} data-id="element-7627" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7628">
                {filteredData.avgInactivityTime} días
              </div>
              <div className="text-sm text-blue-200 mt-2" data-id="element-7629">
                Promedio de tiempo sin respuesta del cliente
              </div>
              <div className="mt-4" data-id="element-7630">
                <div className="flex justify-between items-center mb-1" data-id="element-7631">
                  <span className="text-xs text-blue-200" data-id="element-7632">
                    Cotizaciones inactivas
                  </span>
                  <span className="text-xs text-white" data-id="element-7633">42 cotizaciones</span>
                </div>
                <div className="flex items-center space-x-1" data-id="element-7634">
                  <div className="h-2 bg-red-500 rounded-l w-1/4" data-id="element-7635"></div>
                  <div className="h-2 bg-amber-500 w-1/4" data-id="element-7636"></div>
                  <div className="h-2 bg-yellow-500 w-1/4" data-id="element-7637"></div>
                  <div className="h-2 bg-green-500 rounded-r w-1/4" data-id="element-7638"></div>
                </div>
                <div className="flex justify-between text-xs text-blue-300 mt-1" data-id="element-7639">
                  <span data-id="element-7640">+15 días</span>
                  <span data-id="element-7641">10-15 días</span>
                  <span data-id="element-7642">5-10 días</span>
                  <span data-id="element-7643">&lt;5 días</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7644">
              <div className="flex items-center justify-between mb-2" data-id="element-7645">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7646">
                  Comparativa por Región
                </h3>
                <GlobeIcon className="text-purple-400" size={20} data-id="element-7647" />
              </div>
              <div className="space-y-3 mt-2" data-id="element-7648">
                {filteredRegions.slice(0, 3).map(region => <div key={region.region} data-id="element-7649">
                    <div className="flex justify-between items-center mb-1" data-id="element-7650">
                      <span className="text-sm text-blue-200" data-id="element-7651">
                        {region.region}
                      </span>
                      <span className="text-sm text-white" data-id="element-7652">
                        {region.avgCycleTime} días
                      </span>
                    </div>
                    <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7653">
                      <div className={`h-2 rounded-full ${region.region === 'Latinoamérica' ? 'bg-green-500' : region.region === 'Europa' ? 'bg-blue-500' : region.region === 'Norteamérica' ? 'bg-purple-500' : region.region === 'Asia Pacífico' ? 'bg-amber-500' : 'bg-red-500'}`} style={{
                  width: `${region.avgCycleTime / 20 * 100}%`
                }} data-id="element-7654"></div>
                    </div>
                  </div>)}
                {filteredRegions.length > 3 && <button className="text-xs text-blue-400 hover:text-blue-300 mt-2" data-id="element-7655">
                    Ver todas las regiones
                  </button>}
              </div>
            </div>
          </div>
        </div>}
      {/* Ranking interno */}
      {visibleSections.internalRanking && <div data-id="element-7656">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7657">
            <BarChart3Icon size={18} className="mr-2 text-blue-400" data-id="element-7658" />
            Ranking interno
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7659">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 overflow-hidden" data-id="element-7660">
              <div className="p-4 border-b border-blue-800/30 flex justify-between items-center" data-id="element-7661">
                <h3 className="text-base font-medium text-white flex items-center" data-id="element-7662">
                  <UsersIcon size={16} className="mr-2 text-blue-400" data-id="element-7663" />
                  Top Sales Managers
                </h3>
                <div className="flex space-x-2" data-id="element-7664">
                  <button className="text-xs bg-blue-600 text-white px-2 py-1 rounded-md" data-id="element-7665">
                    Por Valor
                  </button>
                  <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7666">
                    Por Volumen
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto" data-id="element-7667">
                <table className="w-full" data-id="element-7668">
                  <thead data-id="element-7669">
                    <tr className="border-b border-blue-800/30 text-left" data-id="element-7670">
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider" data-id="element-7671">
                        Sales Manager
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider" data-id="element-7672">
                        Región
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7673">
                        Cotizaciones
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7674">
                        Valor Cerrado
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7675">
                        Conversión
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-blue-800/30" data-id="element-7676">
                    {filteredData.salesManagerPerformance.sort((a, b) => b.closedValue - a.closedValue).slice(0, 5).map((manager, index) => <tr key={manager.id} className={`hover:bg-blue-800/20 transition-colors ${selectedManagers.includes(manager.id) ? 'bg-blue-800/30' : ''}`} data-id="element-7677">
                          <td className="px-4 py-3 text-sm text-white font-medium" data-id="element-7678">
                            <div className="flex items-center" data-id="element-7679">
                              <div className={`w-6 h-6 rounded-full ${index === 0 ? 'bg-amber-500' : index === 1 ? 'bg-blue-500' : index === 2 ? 'bg-green-500' : index === 3 ? 'bg-purple-500' : 'bg-red-500'} flex items-center justify-center text-xs text-white mr-2`} data-id="element-7680">
                                {manager.name.split(' ').map(n => n[0]).join('')}
                              </div>
                              {manager.name}
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-blue-200" data-id="element-7681">
                            {manager.region}
                          </td>
                          <td className="px-4 py-3 text-sm text-white text-right" data-id="element-7682">
                            {manager.quotes}
                          </td>
                          <td className="px-4 py-3 text-sm text-green-400 text-right" data-id="element-7683">
                            ${(manager.closedValue / 1000).toFixed(0)}K
                          </td>
                          <td className="px-4 py-3 text-right" data-id="element-7684">
                            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-900/30 text-blue-200 border border-blue-700/30" data-id="element-7685">
                              {manager.conversionRate.toFixed(1)}%
                            </div>
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 overflow-hidden" data-id="element-7686">
              <div className="p-4 border-b border-blue-800/30 flex justify-between items-center" data-id="element-7687">
                <h3 className="text-base font-medium text-white flex items-center" data-id="element-7688">
                  <GlobeIcon size={16} className="mr-2 text-blue-400" data-id="element-7689" />
                  Rendimiento por Región
                </h3>
                <div className="flex space-x-2" data-id="element-7690">
                  <button className="text-xs bg-blue-600 text-white px-2 py-1 rounded-md" data-id="element-7691">
                    Por Conversión
                  </button>
                  <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7692">
                    Por Valor
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto" data-id="element-7693">
                <table className="w-full" data-id="element-7694">
                  <thead data-id="element-7695">
                    <tr className="border-b border-blue-800/30 text-left" data-id="element-7696">
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider" data-id="element-7697">
                        Región
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7698">
                        Cotizaciones
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7699">
                        Ganadas
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7700">
                        Conversión
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7701">
                        Ciclo
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-blue-800/30" data-id="element-7702">
                    {filteredRegions.sort((a, b) => b.conversionRate - a.conversionRate).map(region => <tr key={region.region} className="hover:bg-blue-800/20 transition-colors" data-id="element-7703">
                          <td className="px-4 py-3 text-sm text-white font-medium" data-id="element-7704">
                            {region.region}
                          </td>
                          <td className="px-4 py-3 text-sm text-white text-right" data-id="element-7705">
                            {region.quotes}
                          </td>
                          <td className="px-4 py-3 text-sm text-green-400 text-right" data-id="element-7706">
                            {region.wonQuotes}
                          </td>
                          <td className="px-4 py-3 text-right" data-id="element-7707">
                            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-900/30 text-blue-200 border border-blue-700/30" data-id="element-7708">
                              {region.conversionRate.toFixed(1)}%
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-blue-200 text-right" data-id="element-7709">
                            {region.avgCycleTime} días
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      {/* Charts and Tables - Original content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7710">
        {/* Cotizaciones por Producto */}
        {visibleSections.productCharts && <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 p-5" data-id="element-7711">
            <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-7712">
              <PieChartIcon size={18} className="mr-2 text-blue-400" data-id="element-7713" />
              Cotizaciones por Producto
            </h3>
            <div className="space-y-4" data-id="element-7714">
              {filteredProducts.map(product => <div key={product.product} data-id="element-7715">
                  <div className="flex justify-between items-center mb-1" data-id="element-7716">
                    <div className="text-sm text-blue-200" data-id="element-7717">
                      {product.product}
                    </div>
                    <div className="text-sm text-white" data-id="element-7718">
                      {product.count} cotizaciones ({product.percentage}%)
                    </div>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7719">
                    <div className={`h-2 rounded-full ${product.product === 'Center Pivots' ? 'bg-blue-500' : product.product === 'Linear Systems' ? 'bg-indigo-500' : product.product === 'Drip Irrigation' ? 'bg-green-500' : product.product === 'Micro Sprinklers' ? 'bg-amber-500' : 'bg-purple-500'}`} style={{
                width: `${product.percentage}%`
              }} data-id="element-7720"></div>
                  </div>
                </div>)}
            </div>
          </div>}
        {/* Tendencia de Ventas */}
        {visibleSections.salesTrend && <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 p-5" data-id="element-7721">
            <div className="flex justify-between items-center mb-4" data-id="element-7722">
              <h3 className="text-lg font-medium text-white flex items-center" data-id="element-7723">
                <LineChartIcon size={18} className="mr-2 text-blue-400" data-id="element-7724" />
                Tendencia de Ventas
              </h3>
              <div className="flex space-x-2" data-id="element-7725">
                <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7726">
                  Semanal
                </button>
                <button className="text-xs bg-blue-600 text-white px-2 py-1 rounded-md" data-id="element-7727">
                  Mensual
                </button>
                <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7728">
                  Trimestral
                </button>
              </div>
            </div>
            {/* This would be a line chart in a real implementation */}
            <div className="h-64 flex items-end justify-between px-2" data-id="element-7729">
              {data.salesTrend.map(item => <div key={item.month} className="flex flex-col items-center w-1/7" data-id="element-7730">
                  <div className="relative" data-id="element-7731">
                    <div className="w-12 bg-blue-900/50 rounded-t-md" style={{
                height: `${item.quotes / 400 * 100}%`
              }} data-id="element-7732"></div>
                    <div className="absolute bottom-0 w-12 bg-gradient-to-t from-green-600 to-green-500 rounded-t-md" style={{
                height: `${item.orders / 400 * 100}%`
              }} data-id="element-7733"></div>
                  </div>
                  <div className="text-xs text-blue-300 mt-2" data-id="element-7734">{item.month}</div>
                </div>)}
            </div>
            <div className="flex justify-center mt-2 space-x-6" data-id="element-7735">
              <div className="flex items-center" data-id="element-7736">
                <div className="w-3 h-3 bg-blue-900/50 mr-2" data-id="element-7737"></div>
                <span className="text-xs text-blue-300" data-id="element-7738">Cotizaciones</span>
              </div>
              <div className="flex items-center" data-id="element-7739">
                <div className="w-3 h-3 bg-green-500 mr-2" data-id="element-7740"></div>
                <span className="text-xs text-blue-300" data-id="element-7741">Órdenes</span>
              </div>
            </div>
          </div>}
      </div>
      {/* Modales de filtros - Separados del flujo normal del DOM y con z-index extremadamente alto */}
      {/* Date Picker Modal */}
      {showDatePicker && <div className="fixed inset-0 z-[99999] flex items-start justify-center pt-20" style={{
      backgroundColor: 'rgba(0,0,0,0.5)'
    }} data-id="element-7742">
          <div className="bg-blue-900 border border-blue-700 rounded-xl shadow-2xl p-4 w-full max-w-md mx-4" onClick={e => e.stopPropagation()} data-id="element-7743">
            <div className="mb-3 pb-2 border-b border-blue-800/30 flex justify-between items-center" data-id="element-7744">
              <span className="text-sm font-medium text-white" data-id="element-7745">
                Seleccionar rango de fechas
              </span>
              <button onClick={() => setShowDatePicker(false)} className="text-blue-300 hover:text-white" data-id="element-7746">
                <XIcon size={20} data-id="element-7747" />
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7748">
              <div data-id="element-7749">
                <label className="block text-xs font-medium text-blue-300 mb-1" data-id="element-7750">
                  Fecha de inicio
                </label>
                <input type="date" value={dateRange.startDate} max={dateRange.endDate} onChange={e => handleDateChange('startDate', e.target.value)} className="w-full bg-blue-800/50 border border-blue-700/40 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-7751" />
              </div>
              <div data-id="element-7752">
                <label className="block text-xs font-medium text-blue-300 mb-1" data-id="element-7753">
                  Fecha de fin
                </label>
                <input type="date" value={dateRange.endDate} min={dateRange.startDate} onChange={e => handleDateChange('endDate', e.target.value)} className="w-full bg-blue-800/50 border border-blue-700/40 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-7754" />
              </div>
            </div>
            <div className="mt-4 flex justify-end" data-id="element-7755">
              <button onClick={() => {
            setSelectedDateRange('custom');
            setIsCustomDateRange(true);
            setShowDatePicker(false);
          }} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors" data-id="element-7756">
                Aplicar rango
              </button>
            </div>
          </div>
        </div>}
      {/* Manager Selection Modal */}
      {showManagerFilter && <div className="fixed inset-0 z-[99999] flex items-center justify-center" style={{
      backgroundColor: 'rgba(0,0,0,0.5)'
    }} onClick={() => setShowManagerFilter(false)} data-id="element-7757">
          <div className="bg-blue-900 border border-blue-700 rounded-xl shadow-2xl p-4 w-full max-w-md mx-4" onClick={e => e.stopPropagation()} data-id="element-7758">
            <div className="flex justify-between items-center mb-3 pb-2 border-b border-blue-800" data-id="element-7759">
              <span className="text-lg font-medium text-white" data-id="element-7760">
                Seleccionar gerentes de ventas
              </span>
              <button onClick={() => setShowManagerFilter(false)} className="text-blue-300 hover:text-white" data-id="element-7761">
                <XIcon size={20} data-id="element-7762" />
              </button>
            </div>
            <div className="mb-3 flex justify-between items-center" data-id="element-7763">
              <span className="text-sm text-blue-200" data-id="element-7764">
                {selectedManagers.length} de {filteredSalesManagers.length}{' '}
                seleccionados
              </span>
              <button onClick={() => setSelectedManagers([])} className="text-xs text-blue-300 hover:text-white px-2 py-1 bg-blue-800/50 hover:bg-blue-800/70 rounded-md" data-id="element-7765">
                Limpiar selección
              </button>
            </div>
            <div className="space-y-1 max-h-60 overflow-y-auto pr-1 mb-3" data-id="element-7766">
              {filteredSalesManagers.map(manager => <div key={manager.id} className={`flex items-center p-3 hover:bg-blue-800/50 rounded-md cursor-pointer transition-colors ${selectedManagers.includes(manager.id) ? 'bg-blue-800/30' : ''}`} onClick={() => toggleManager(manager.id)} data-id="element-7767">
                  <div className={`w-8 h-8 rounded-full ${manager.color} flex items-center justify-center text-sm font-medium text-white mr-3`} data-id="element-7768">
                    {manager.avatar}
                  </div>
                  <div className="flex-1" data-id="element-7769">
                    <span className="text-sm text-white font-medium block" data-id="element-7770">
                      {manager.name}
                    </span>
                    <span className="text-xs text-blue-300" data-id="element-7771">
                      {manager.region}
                    </span>
                  </div>
                  <div className="ml-auto" data-id="element-7772">
                    <div className={`w-6 h-6 rounded-md ${selectedManagers.includes(manager.id) ? 'bg-blue-500 border-blue-500' : 'bg-blue-900/60 border-blue-700/40'} border flex items-center justify-center`} data-id="element-7773">
                      {selectedManagers.includes(manager.id) && <CheckIcon size={16} className="text-white" data-id="element-7774" />}
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="flex justify-end space-x-2 pt-2 border-t border-blue-800" data-id="element-7775">
              <button onClick={() => setShowManagerFilter(false)} className="px-4 py-2 bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 rounded-lg transition-colors" data-id="element-7776">
                Cancelar
              </button>
              <button onClick={() => setShowManagerFilter(false)} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors" data-id="element-7777">
                Aplicar filtros
              </button>
            </div>
          </div>
        </div>}
    </div>;
}
function CustomerAnalyticsSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="space-y-6" data-id="element-7778">
      {/* KPI Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-7779">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7780">
          <div className="flex items-center justify-between mb-2" data-id="element-7781">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7782">
              Total Customers
            </h3>
            <UsersIcon className="text-blue-400" size={20} data-id="element-7783" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7784">
            {data.totalCustomers.toLocaleString()}
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7785">
            <div className="flex items-center text-green-400" data-id="element-7786">
              <ArrowUpIcon size={14} className="mr-1" data-id="element-7787" />
              <span data-id="element-7788">{data.newCustomersThisMonth} new this month</span>
            </div>
          </div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7789">
          <div className="flex items-center justify-between mb-2" data-id="element-7790">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7791">
              Active Customers
            </h3>
            <HeartIcon className="text-green-400" size={20} data-id="element-7792" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7793">
            {data.activeCustomers.toLocaleString()}
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7794">
            <div className="flex items-center text-blue-300" data-id="element-7795">
              <span data-id="element-7796">
                {(data.activeCustomers / data.totalCustomers * 100).toFixed(1)}
                % of total
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7797">
          <div className="flex items-center justify-between mb-2" data-id="element-7798">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7799">
              Retention Rate
            </h3>
            <ThumbsUpIcon className="text-amber-400" size={20} data-id="element-7800" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7801">
            {data.customerRetentionRate}%
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7802">
            <div className="flex items-center text-blue-300" data-id="element-7803">
              <span data-id="element-7804">Year-over-year</span>
            </div>
          </div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7805">
          <div className="flex items-center justify-between mb-2" data-id="element-7806">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7807">
              Active Dealers
            </h3>
            <BuildingIcon className="text-purple-400" size={20} data-id="element-7808" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7809">
            {data.activeDealers}/{data.totalDealers}
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7810">
            <div className="flex items-center text-blue-300" data-id="element-7811">
              <span data-id="element-7812">
                {(data.activeDealers / data.totalDealers * 100).toFixed(1)}%
                active
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* ... rest of existing code ... */}
    </div>;
}
function MarketInsightsSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="space-y-6" data-id="element-7813">{/* ... existing code ... */}</div>;
}
function QuoteIntelligenceSection({
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="flex items-center justify-center h-64 p-6" data-id="element-7814">
      {/* ... existing code ... */}
    </div>;
}
function RevenueIntelligenceSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="space-y-6" data-id="element-7815">{/* ... existing code ... */}</div>;
}
function EngagementSection({
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="flex items-center justify-center h-64 p-6" data-id="element-7816">
      {/* ... existing code ... */}
    </div>;
}
function ExecutiveInsightsSection({
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="flex items-center justify-center h-64 p-6" data-id="element-7817">
      {/* ... existing code ... */}
    </div>;
}